import { render } from "./FixedMenu.vue?vue&type=template&id=15c025a4&scoped=true"
import script from "./FixedMenu.vue?vue&type=script&lang=js"
export * from "./FixedMenu.vue?vue&type=script&lang=js"

import "./FixedMenu.vue?vue&type=style&index=0&id=15c025a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15c025a4"]])

export default __exports__